/**
 * Realtime Service Module
 *
 * Exports the RealtimeService singleton for real-time data synchronization.
 */

import { supabase } from '@/services/database/client';
import { useAuthStore } from '@/stores/authStore';
import { useLearningStore } from '@/stores/learningStore';
import { createAuthStoreAdapter, createLearningStoreAdapter } from '@/services/adapters/store.adapters';
import { RealtimeService } from './realtime.service';

/**
 * Singleton RealtimeService instance
 * Initialized with Supabase client and store adapters
 */
export const realtimeService = new RealtimeService(
  supabase,
  createAuthStoreAdapter(useAuthStore),
  createLearningStoreAdapter(useLearningStore)
);

/**
 * Export class for testing (can mock dependencies)
 */
export { RealtimeService };
